var React = require('react');

function Volume1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M58.16 17.84C61.9094 21.5906 64.0157 26.6767 64.0157 31.98C64.0157 37.2833 61.9094 42.3694 58.16 46.12M40 4L20 20H4V44H20L40 60V4Z","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Volume1.defaultProps = {"width":"69","height":"64","viewBox":"0 0 69 64","fill":"none"};

module.exports = Volume1;

Volume1.default = Volume1;
